import { z } from 'zod';
export const CLINIC_TIMEZONE = 'America/Sao_Paulo';
export const CLINIC_LOCALE = 'pt-BR';
export const CURRENCY = 'BRL';
export const SCHEDULE_SLOT_MINUTES = 5;
export const MAX_CHAT_ATTACHMENT_BYTES = 10 * 1024 * 1024;
export const MAX_PROFILE_PHOTO_BYTES = 2 * 1024 * 1024;
export const MAX_PATIENT_SEARCH_RESULTS = 25;
export const DEFAULT_SCHEDULING_ALERT_NOTE = 'Pagamento antecipado necessário';
export const MAX_SCHEDULING_ALERT_NOTE_LENGTH = 500;
export const roleSchema = z.enum(['medico', 'secretaria']);
export const appointmentLifecycleSchema = z.enum([
    'pending_scheduling_confirmation',
    'scheduled',
    'confirmed',
    'completed',
    'no_show',
    'rescheduled',
    'cancelled',
]);
export const paymentStateSchema = z.enum([
    'pending',
    'partially_paid',
    'paid',
    'partially_refunded',
    'refunded',
]);
export const taskStatusSchema = z.enum(['pending', 'in_progress', 'completed', 'cancelled']);
export const taskPrioritySchema = z.enum(['low', 'normal', 'high', 'urgent']);
export const schedulingAlertModeSchema = z.enum([
    'dashboard_and_scheduling',
    'scheduling_only',
    'discarded',
]);
export const paymentMethodSchema = z.enum([
    'pix',
    'cash',
    'credit_card',
    'debit_card',
    'transfer',
    'other',
]);
export const chatAttachmentMimeTypes = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'application/pdf',
];
export const profilePhotoMimeTypes = ['image/jpeg', 'image/png', 'image/webp'];
export const userFacingRoleLabel = {
    medico: 'Médico',
    secretaria: 'Secretária',
};
export const userFacingLifecycleLabel = {
    pending_scheduling_confirmation: 'Aguardando confirmação de agendamento',
    scheduled: 'Agendamento confirmado — aguardando confirmação da consulta',
    confirmed: 'Consulta confirmada',
    completed: 'Realizada',
    no_show: 'Paciente faltou',
    rescheduled: 'Reagendada',
    cancelled: 'Cancelada',
};
export const userFacingPaymentLabel = {
    pending: 'Pendente',
    partially_paid: 'Parcialmente paga',
    paid: 'Paga',
    partially_refunded: 'Parcialmente devolvida',
    refunded: 'Devolvida',
};
//# sourceMappingURL=constants.js.map